"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div style={{ padding: "var(--s5, 32px) var(--gutter, 24px)", maxWidth: 720 }}>
      <h2 className="h3" style={{ marginBottom: 12 }}>
        Page failed to load
      </h2>
      <p className="muted" style={{ marginBottom: 16, lineHeight: 1.5 }}>
        Often this is a bad API URL (e.g. <code>localhost</code> from another machine) or Turbopack blocking
        the dev host (use <code>http://127.0.0.1:3030</code> vs <code>localhost</code> consistently). Check{" "}
        <code>API_BASE_URL</code>, <code>NEXT_PUBLIC_API_BASE_URL</code>, and{" "}
        <code>NEXT_ALLOWED_DEV_ORIGINS</code> in <code>next.config</code> / env.
      </p>
      <pre
        style={{
          overflow: "auto",
          fontSize: 13,
          padding: 14,
          borderRadius: 12,
          border: "1px solid var(--border, #e5e7eb)",
          background: "var(--surface, #fff)",
          whiteSpace: "pre-wrap",
        }}
      >
        {error.message}
      </pre>
      <button type="button" className="btn btnPrimary" style={{ marginTop: 20 }} onClick={() => reset()}>
        Try again
      </button>
    </div>
  );
}
